export const MEMBERSHIP_AWARD_COUNT_LIMITS_PATH = 'awardCount.membershipAwardCountLimits';
export const GLOBAL_AWARD_COUNT_LIMITS_PATH = 'awardCount.globalAwardCountLimits';
